import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProductDetailPage from "@/pages/AdminProductDetailPage";
import AdminFeaturesPage from "@/pages/AdminFeaturesPage";
import AdminCategoriesPage from "@/pages/AdminCategoriesPage";
import CustomerCatalog from "@/pages/CustomerCatalog";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CustomerCatalog />} />
          <Route path="/catalog/:slug" element={<CustomerCatalog />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/products/:productId"
            element={
              <ProtectedRoute>
                <AdminProductDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/features"
            element={
              <ProtectedRoute>
                <AdminFeaturesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/categories"
            element={
              <ProtectedRoute>
                <AdminCategoriesPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
